import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SuccessModal from '../../components/global/SuccessModal';

import Typography from '../../components_/Typography';
import { Box, Flex, Img, Input } from '@chakra-ui/react';
import { Colors } from '../../utils/constants';
import { arrowLeft } from '../../assets/images/login';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { VALIDATIONS } from '../../utils/validations';
import { useGetPasswordRecoveryLink } from '../../apis/auth';
import customToast, { ToastType } from '../../components_/Toast';
import ForgotPasswordSuccessModal from './ForgotPasswordSuccessModal';
import Button from '../../components_/button';

type TProps = {
  setRecoveryLinkSent: React.Dispatch<React.SetStateAction<boolean>>;
  setUserEmail: React.Dispatch<React.SetStateAction<string>>;
};
export function ForgotPasswordForm() {
  const navigate = useNavigate();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const formik = useFormik({
    initialValues: { email: '' },
    validationSchema: yup.object({
      email: VALIDATIONS.email,
    }),
    onSubmit: () => refetch(),
  });

  const { isSuccess, isLoading, refetch } = useGetPasswordRecoveryLink({
    email: formik?.values?.email,
  });

  return (
    <>
      <Box
        bgColor={'white'}
        px={{ base: '2rem', md: '3.5rem' }}
        py={'2rem'}
        borderRadius={'0.5rem'}
      >
        <Flex
          mb={'2rem'}
          alignItems={'center'}
          gap={'8px'}
          cursor={'pointer'}
          onClick={() => navigate('/')}
        >
          <Img src={arrowLeft} boxSize={{ base: '1rem', md: '1.5rem' }} />
          <Typography color={Colors.green} fontSize={'0.7rem'} fontWeight={500}>
            Back
          </Typography>
        </Flex>

        <Box mb={'2rem'}>
          <Typography color={Colors.black} fontSize={'1.125rem'} fontWeight={700} mb={'1rem'}>
            Password Recovery
          </Typography>
          <Typography color={Colors.black} fontSize={'0.75rem'} fontWeight={400} mb={'1.5rem'}>
            Enter your email address, we will send you a link to recover your password.
          </Typography>
          <Input
            borderRadius={'0.25rem'}
            border={`0.5px solid ${Colors.secondaryGreen300}`}
            placeholder='Email address'
            type={'email'}
            fontSize={'0.75rem'}
            fontWeight={400}
            flex={1}
            height={'2.8125rem'}
            onChange={(e) => formik.setFieldValue('email', e.target.value)}
            _placeholder={{
              mt: '-10px',
            }}
            value={formik.values.email}
            px={{ base: '0.75rem', md: '1rem' }}
            _focusVisible={{
              outlineColor: 'none',
              border: `2px solid ${Colors.green}`,
            }}
            fontFamily={'Poppins'}
          />

          {formik?.touched?.email && formik?.errors?.email && (
            <Typography color={'red'} fontSize={'11px'} fontWeight={400}>
              {formik?.errors?.email}
            </Typography>
          )}
        </Box>
        <Button
          width={'100%'}
          isLoading={isLoading}
          onClick={() => formik.handleSubmit()}
          py={'1rem'}
          height={{ base: '2.5rem', md: '2.875rem' }}
          text={'SEND RECOVERY LINK'}
        />
      </Box>

      <ForgotPasswordSuccessModal
        description={
          'A password reset link has been sent to your email. Kindly check your inbox, and follow the instructions. If not found, check your spam folder'
        }
        header={'Recovery Link Sent'}
        proceedText={'CLOSE'}
        setShowSuccessModal={setShowSuccessModal}
        showSuccessModal={isSuccess}
      />
    </>
  );
}
